// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_generalContent__6Cs7F {
  background: #fff;
  padding: 32px;
  border-radius: 8px;
  width: 100%;
  max-width: 640px;
}

.page_addAddressContent__L\\+S45 {
  border: 1px solid black;
  border-radius: 8px;
  margin-top: 15px;
  padding: 24px;
}

.page_generalRow__MCnhK {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.page_formControltems__ik0dT {
  width: 100%;
}

.page_formControlInputs__k7Kf0 {
  display: flex;
  gap: 24px;
}

.page_formControlFull__oovpy {
  width: 100%;
}

.page_formControlFields__Ulli6 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.page_fieldsLabel__Tu\\+sk {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #111827;
}

/* Input fields */

textarea.page_inputFields__kAT7y{
  resize: none;
}
.page_inputFields__kAT7y {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.page_inputFieldsIcon__TScXh {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
}

.page_inputFieldsIcon__TScXh img {
  width: 18px;
  height: 18px;
}

.page_userEmail__6Eceo img {
  width: 18px;
}

/* Profile section */
.page_profilePictureItems__O4GGS {
  display: flex;
  align-items: center;
  gap: 20px;
}

.page_avatarUpload__ZyRwO {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
}

.page_profileImagePreview__a4FdR {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.page_newPageRightRow__TSpdl {
  cursor: pointer;
}

.page_profileImageText__TmB8W {
  font-size: 14px;
  line-height: 20px;
  color: #374151;
}

.page_uploadBtn__u-TSF {
  background: transparent;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 13px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  box-shadow: 0 1px 3px #0000001a;
  margin-top: 5px;
}

.page_buttonsGroup__aQV2p,
.page_radioGroup__haGuR {
  display: flex;
  gap: 18px;
  align-items: center;
}

.page_radioGroupItem__Hs\\+a\\+ {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Save Button */
.page_saveButton__f-7IK {
  background: #111827;
  color: #fff;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  width: 138.03px;
  height: 39px;
}

.page_addNewAddress__vPd4n {
  background: #111827;
  color: #fff;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
}

.page_addressList__g24Fx {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-block: 24px;
}

.page_addressCard__c6Imk {
  position: relative;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 16px 16px 16px 16px;
  background: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.page_addressType__YoPac {
  position: absolute;
  top: -10px;
  left: 16px;
  background: #f1f3f6;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 4px;
  color: #333;
  font-weight: 500;
}

.page_addressContent__zKSnF {
  max-width: 75%;
}

.page_addressHeader__hYB7y {
  display: flex;
  gap: 12px;
  font-weight: 600;
  font-size: 16px;
  color: #222;
}

.page_addressPhone__6sbOY {
  font-weight: 500;
  color: #000;
}

.page_addressText__dVJmI {
  margin-top: 6px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.page_addressActions__DcpLC {
  position: relative;
  display: flex;
  gap: 8px;
}

.page_iconButton__opJTr {
  border: 0;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page_iconButtonDelete__6ieZC {
  border: 0;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page_iconButton__opJTr , .page_iconButtonDelete__6ieZC{
  height: 16px;
  width: 16px;
}

.page_moreButton__tZsC0 {
  border: 0;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  width: 16px;
}

.page_dropdown__k3OAZ {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 100px;
}

.page_dropdownItem__oItbh {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 14px;
  color: #333;
}

.page_dropdownItem__oItbh:hover {
  background: #f5f5f5;
}

.page_dropdownItem__oItbh img {
  width: 14px;
  height: 14px;
}

.page_radioGroupItem__Hs\\+a\\+ label{
  cursor: pointer;
}

.page_buttonSaveLast__Duc75{
  border-top: 1px solid #d4d4d4;
  justify-content: end;
  padding: 32px;
}

.page_buttonSaveLast__Duc75 button{
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Subscribers/page.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".generalContent {\n  background: #fff;\n  padding: 32px;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 640px;\n}\n\n.addAddressContent {\n  border: 1px solid black;\n  border-radius: 8px;\n  margin-top: 15px;\n  padding: 24px;\n}\n\n.generalRow {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.formControltems {\n  width: 100%;\n}\n\n.formControlInputs {\n  display: flex;\n  gap: 24px;\n}\n\n.formControlFull {\n  width: 100%;\n}\n\n.formControlFields {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.fieldsLabel {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #111827;\n}\n\n/* Input fields */\n\ntextarea.inputFields{\n  resize: none;\n}\n.inputFields {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n}\n\n.inputFieldsIcon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n}\n\n.inputFieldsIcon img {\n  width: 18px;\n  height: 18px;\n}\n\n.userEmail img {\n  width: 18px;\n}\n\n/* Profile section */\n.profilePictureItems {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.avatarUpload {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.profileImagePreview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.newPageRightRow {\n  cursor: pointer;\n}\n\n.profileImageText {\n  font-size: 14px;\n  line-height: 20px;\n  color: #374151;\n}\n\n.uploadBtn {\n  background: transparent;\n  border-radius: 6px;\n  padding: 4px 12px;\n  font-size: 13px;\n  border: 1px solid #d1d5db;\n  cursor: pointer;\n  box-shadow: 0 1px 3px #0000001a;\n  margin-top: 5px;\n}\n\n.buttonsGroup,\n.radioGroup {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n}\n\n.radioGroupItem {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Save Button */\n.saveButton {\n  background: #111827;\n  color: #fff;\n  padding: 10px 18px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  border: none;\n  width: 138.03px;\n  height: 39px;\n}\n\n.addNewAddress {\n  background: #111827;\n  color: #fff;\n  padding: 10px 18px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  border: none;\n}\n\n.addressList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-block: 24px;\n}\n\n.addressCard {\n  position: relative;\n  border: 1px solid #e5e5e5;\n  border-radius: 8px;\n  padding: 16px 16px 16px 16px;\n  background: #fff;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.addressType {\n  position: absolute;\n  top: -10px;\n  left: 16px;\n  background: #f1f3f6;\n  padding: 4px 10px;\n  font-size: 12px;\n  border-radius: 4px;\n  color: #333;\n  font-weight: 500;\n}\n\n.addressContent {\n  max-width: 75%;\n}\n\n.addressHeader {\n  display: flex;\n  gap: 12px;\n  font-weight: 600;\n  font-size: 16px;\n  color: #222;\n}\n\n.addressPhone {\n  font-weight: 500;\n  color: #000;\n}\n\n.addressText {\n  margin-top: 6px;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.addressActions {\n  position: relative;\n  display: flex;\n  gap: 8px;\n}\n\n.iconButton {\n  border: 0;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.iconButtonDelete {\n  border: 0;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.iconButton , .iconButtonDelete{\n  height: 16px;\n  width: 16px;\n}\n\n.moreButton {\n  border: 0;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 16px;\n  width: 16px;\n}\n\n.dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  min-width: 100px;\n}\n\n.dropdownItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n  color: #333;\n}\n\n.dropdownItem:hover {\n  background: #f5f5f5;\n}\n\n.dropdownItem img {\n  width: 14px;\n  height: 14px;\n}\n\n.radioGroupItem label{\n  cursor: pointer;\n}\n\n.buttonSaveLast{\n  border-top: 1px solid #d4d4d4;\n  justify-content: end;\n  padding: 32px;\n}\n\n.buttonSaveLast button{\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalContent": `page_generalContent__6Cs7F`,
	"addAddressContent": `page_addAddressContent__L+S45`,
	"generalRow": `page_generalRow__MCnhK`,
	"formControltems": `page_formControltems__ik0dT`,
	"formControlInputs": `page_formControlInputs__k7Kf0`,
	"formControlFull": `page_formControlFull__oovpy`,
	"formControlFields": `page_formControlFields__Ulli6`,
	"fieldsLabel": `page_fieldsLabel__Tu+sk`,
	"inputFields": `page_inputFields__kAT7y`,
	"inputFieldsIcon": `page_inputFieldsIcon__TScXh`,
	"userEmail": `page_userEmail__6Eceo`,
	"profilePictureItems": `page_profilePictureItems__O4GGS`,
	"avatarUpload": `page_avatarUpload__ZyRwO`,
	"profileImagePreview": `page_profileImagePreview__a4FdR`,
	"newPageRightRow": `page_newPageRightRow__TSpdl`,
	"profileImageText": `page_profileImageText__TmB8W`,
	"uploadBtn": `page_uploadBtn__u-TSF`,
	"buttonsGroup": `page_buttonsGroup__aQV2p`,
	"radioGroup": `page_radioGroup__haGuR`,
	"radioGroupItem": `page_radioGroupItem__Hs+a+`,
	"saveButton": `page_saveButton__f-7IK`,
	"addNewAddress": `page_addNewAddress__vPd4n`,
	"addressList": `page_addressList__g24Fx`,
	"addressCard": `page_addressCard__c6Imk`,
	"addressType": `page_addressType__YoPac`,
	"addressContent": `page_addressContent__zKSnF`,
	"addressHeader": `page_addressHeader__hYB7y`,
	"addressPhone": `page_addressPhone__6sbOY`,
	"addressText": `page_addressText__dVJmI`,
	"addressActions": `page_addressActions__DcpLC`,
	"iconButton": `page_iconButton__opJTr`,
	"iconButtonDelete": `page_iconButtonDelete__6ieZC`,
	"moreButton": `page_moreButton__tZsC0`,
	"dropdown": `page_dropdown__k3OAZ`,
	"dropdownItem": `page_dropdownItem__oItbh`,
	"buttonSaveLast": `page_buttonSaveLast__Duc75`
};
export default ___CSS_LOADER_EXPORT___;
